export const getCountries = (state) => state.countries
export const getCountry = (state) => (id) => { return state.countries.find((country) => { return country.id === id }) }
